module.exports = __webpack_public_path__ + "img/1faab.348d267.svg";